module.exports = __webpack_public_path__ + "img/act-人事管理.acc782f4.png";